import { z } from 'zod';
export const AccountOwnerSchema = z.object({
    id: z.uuid().nullish(),
    email: z.email().nullish(),
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
});
